var Backbone, FAQAutoCompleteItemView, FaqAutocompleteItemTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqAutocompleteItemTemplate = require('../../autocompleteItem.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

FAQAutoCompleteItemView = (function(superClass) {
  extend(FAQAutoCompleteItemView, superClass);

  function FAQAutoCompleteItemView() {
    return FAQAutoCompleteItemView.__super__.constructor.apply(this, arguments);
  }

  FAQAutoCompleteItemView.prototype.tagName = 'li';

  FAQAutoCompleteItemView.prototype.className = 'siblings';

  FAQAutoCompleteItemView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    return this.template = FaqAutocompleteItemTemplate;
  };

  FAQAutoCompleteItemView.prototype.render = function(hash) {
    if (hash == null) {
      hash = {};
    }
    this.$el.html(toHtml(this.template, this.toHash(hash), this.I18nScope));
    return this.$el.attr("index", "" + hash.index);
  };

  FAQAutoCompleteItemView.prototype.toHash = function(hash) {
    var ref;
    if ((hash != null ? (ref = hash.item) != null ? ref.type : void 0 : void 0) != null) {
      switch (hash.item.type) {
        case 0:
          hash.item.text = this.highlightText(hash.keyword, hash.item.topic_text);
          break;
        case 1:
          hash.item.text = this.highlightText(hash.keyword, hash.item.article_heading);
      }
      return hash;
    } else {
      return hash;
    }
  };

  FAQAutoCompleteItemView.prototype.highlightText = function(keyword, text) {
    var keywords;
    if ((keyword != null) && text) {
      text = text.replace(/(<([^>]+)>)/ig, "");
      keywords = keyword.split(/\s+/);
      _.each(keywords, function(word, index) {
        var searchPattern;
        if (!(word === 'b' && index > 0)) {
          searchPattern = new RegExp('(' + word + ')', 'ig');
          return text = text.replace(searchPattern, "<b>$1</b>");
        }
      });
      return text;
    } else {
      return text;
    }
  };

  return FAQAutoCompleteItemView;

})(Backbone.View);

module.exports = FAQAutoCompleteItemView;

//# sourceMappingURL=data:application/json;base64,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
